import { createStore } from 'zustand/vanilla';
import { Config, isSummary } from './helper';
import { fetchPathwayProgress, updateStepStatus } from './api';

const FINISHED_STATUSES = [Config.Step.Status.completed,];

const PASSED_STATUSES = [Config.Step.Status.completed, Config.Step.Status.skipped,]

export const pathwayStore = createStore((set, get) => ({
  pathwayID: null,
  componentState: Config.State.initial,
  userState: Config.UserState.unknown,
  userProgress: [],
  description: '',
  steps: [],
  breadcrumbs: [],
  errors: [],
  updatePathwayID: (value) => set({pathwayID: value}),
  updateDescription: (value) => set({description: value}),
  updateUserState: (value) => set({userState: value}),
  updateUserProgress: (value) => set({userProgress: value}),
  updateComponentState: (value) => set({componentState: value}),
  updateSteps: (value) => set({steps: value}),
  updateBreadcrumbs: (value) => set({breadcrumbs: value}),
  setErrors: (value) => set({errors: value}),
  currentProgress: () => {
    const {steps, completedStepIDs} = get();

    if (!steps.length) {
      return 0
    }

    const completedIDs = completedStepIDs();
    const total = steps.reduce((acc, step) => {
      const {score = 0} = step;
      return acc + score;
    }, 0);

    const completed = steps.filter(step => completedIDs.includes(step.id)).reduce((acc, step) => acc + step.score, 0);
    return Math.round((completed / total) * 100);
  },
  updateStep: (id, step, status) => {
    const {setErrors} = get();
    updateStepStatus(id, step.id, status)
      .then(() => fetchPathwayProgress(get().pathwayID))
      .then((progressData) => {
        get().updateUserProgress(progressData);
      })
      .catch(error => {
        console.log(error.message);
        setErrors([error.message])
      });
  },
  currentStep: () => {
    const {steps, userProgress} = get();
    let current = null;

    const firstNotStarted = userProgress.find(step => step.status === Config.Step.Status.notStarted) || null;
    if (firstNotStarted) {
      current = steps.find((step) => firstNotStarted.step_id === step.id) || null;
    }

    return current;
  },
  stepUserData: (idToFind) => {
    const {userProgress} = get();
    if (!userProgress || userProgress.length === 0) {
      return null
    }

    const item = userProgress.find(i => i.step_id === idToFind);
    if (!item) {
      return null;
    }

    return item?.data;
  },
  completedStepIDs: () => {
    return get().userProgress.filter(step => FINISHED_STATUSES.includes(step.status)).map(s => s.step_id);
  },
  passedStepIDs: () => {
    return get().userProgress.filter(step => PASSED_STATUSES.includes(step.status)).map(s => s.step_id);
  },
  skippedStepIDs: () => {
    return get().userProgress.filter(step => step.status === Config.Step.Status.skipped).map(s => s.step_id);
  },
  isAllMainStepsCompleted: () => {
    const {currentProgress, userProgress, steps} = get();
    const progressMap = new Map(userProgress.map(({ step_id, status }) => [step_id, status]));
    const stepsExceptSummary = steps.filter(step => !isSummary(step.format))

    const results = stepsExceptSummary.map(step => {
      return progressMap.get(step.id);
    })
    const allDone = results.every(s => s === Config.Step.Status.completed || s === Config.Step.Status.skipped);
    return allDone;
  }
}));
